module.exports = __webpack_public_path__ + "static/2010-layer-1-a158dfd951a747ece88c0a6a9f0d90b2.png";